<div class="body-content">
    <div  class="map_wrapper">
        <div class="map" id="map" class="match-parent"></div>
    </div>
</div>
